import ReactSelect from "@common/ReactSelect";
import { useEffect, useRef, useState } from "react";
import CommonModel from "@pages/commission/commonModel";
import * as HELPER from "@src/config/helper";
import { CREATE_PAGE_INDEX, ROLE } from "@src/config/id/constant";
import { 
    handleManualPremiumChange,
    handleCoverageChange,
    handlePassengerChange,
    totalAddonCostBtRange,
    handleCheckboxChange,
    updateAddons 
} from './functions/addon.fn';
import { WITH_RULE_ENGINE } from "@src/config/constant";
import { useLanguage } from "@src/context/LanguageContext";
import secureStorage from "@src/config/encrypt";

interface AddonProps {
  getSectionFields: (...args: any[]) => any;
  addonState: Record<string, any>;
  setAddonState: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  error: Record<string, any>;
  setError: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  basicAddons: Record<string,any>[];
  specialAddons: Record<string,any>[];
  onSubmitAddons:(...args: any[]) => any,
  handleSkip:() => void
  addOnQuesAns:any,
  sectionList?:any,
  fetchAddons?:any,
  isEdit?:boolean
}

const Addons = (props: AddonProps) => {

    const {
        getSectionFields,
        addonState,
        setAddonState,
        error,
        setError,
        basicAddons,
        specialAddons,
        onSubmitAddons,
        handleSkip,
        addOnQuesAns,
        sectionList,
        fetchAddons,
        isEdit
    } = props

    const sectionData = getSectionFields(CREATE_PAGE_INDEX.CREATE)
    const authUserInfo = secureStorage.getItem("authAgentUserInfo") || {};
    const roleId = authUserInfo?.user_data?.role_id || authUserInfo?.role_id;
    const ruleEngine = sectionData?.rule_engine || (roleId === ROLE.AGENT ? WITH_RULE_ENGINE : sectionData?.rule_engine);
    const requestData = {
        ...sectionData,
        rule_engine: ruleEngine
    };
    const isRuleEngine = ruleEngine === WITH_RULE_ENGINE;
    const policyTenure = Math.min(5, Math.max(1, Number(requestData?.tenure) || 1));
    const [showHelpModel, setShowHelpModel] = useState(false);
    const [openApplicableInfoId, setOpenApplicableInfoId] = useState<number | null>(null);
    const applicableInfoRef = useRef<HTMLDivElement | null>(null);
    const {translations} = useLanguage();

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            if (
                applicableInfoRef.current &&
                !applicableInfoRef.current.contains(event.target as Node)
            ) {
                setOpenApplicableInfoId(null);
            }
        };

        updatedPremiumAmt();
        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleCheckboxChangeLoc = (item:any,value:boolean)=>{
        handleCheckboxChange(requestData, setAddonState,item,value,setError);
    }

    const handleCoverageChangeLoc = (addon: any, selected: any) => {
        handleCoverageChange(addon, selected, setAddonState, isRuleEngine);
    };

    const handlePassengerChangeLoc = (addon: any, selected: any) => {
        handlePassengerChange(addon, selected, setAddonState,requestData,addonState);
    };

    const handleManualPremiumChangeLoc = (addon: any, value: any) => {
        handleManualPremiumChange(addon, value, setAddonState, setError);
    };

    const handleSubmit = async () => {
        const addons = await updateAddons(requestData, addonState, setError,translations);   
        if(addons?.errors && Object.keys(addons?.errors).length > 0) return;
        onSubmitAddons(CREATE_PAGE_INDEX.ADDONS, addons);
    };

    const totalPremiumAmt = totalAddonCostBtRange(addonState, isRuleEngine, policyTenure);

    const updatedPremiumAmt = async ()=>{      

        let response:any = null;
        
        if(isEdit){
            response = basicAddons;
        }else{
            response = await fetchAddons(requestData,true);
        }
        if(response){
            const updatePrimiumState = {...addonState}
            for(let row of response){       
                if(updatePrimiumState && updatePrimiumState?.[row.id]){
                    if(row?.coverage_list?.length === 0 && isRuleEngine){
                        updatePrimiumState[row.id] = {
                            ...updatePrimiumState[row.id],
                            premium: row.premium_amount
                        }
                    }
                }
            }
            setAddonState(updatePrimiumState)
        }
    }
    

    return (
        <div className="basic-add-on-outer">
            <div className="row">
                <div className="heading-help-btn col-md-7 col-xs-12 p-sm-b">
                    <h2>{translations?.CREATE_APP?.BASIC_ADDNONS}</h2>
                    <button className="btn-help" onClick={() => setShowHelpModel(true)}>
                        {translations?.CREATE_APP?.HELP}
                    </button>
                </div>
            </div>

            <div className="row">
                <div className="col-md-8 col-xs-12">
                    <div className="basic-add-on-list">

                        <ul>
                            {basicAddons.map((item: any) => {
                                const state = addonState[item.id] || {};
                                const premiumText = HELPER.addCurrencyFormatting(state.premium) || "";
                                const applicableYears = item.applicable_initial_years ?? policyTenure;
                                const applicableYearsText = (translations?.MULTIYEAR?.APPLICABLE_INITIAL_YEARS || "").replace(
                                    /\{\{years\}\}/g,
                                    String(applicableYears)
                                );
                                const applicableYearsPopupText = translations?.MULTIYEAR?.APPLICABLE_INITIAL_YEARS_TOOLTIP?.replace(
                                    /\{\{years\}\}/g,
                                    String(applicableYears)
                                ) || `This add on will only be applicable for the initial ${applicableYears} years of the coverage.`;
                               
                                return (

                                    <li key={item.id}>
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                id={`basic_${item.id}`}
                                                type="checkbox"
                                                className="custom-control-input"
                                                checked={state.checked || false}
                                                onChange={(e) =>
                                                    handleCheckboxChangeLoc(item, e.target.checked)
                                                }
                                            // disabled={!item.is_enable}
                                            />
                                            <label
                                                className="custom-control-label"
                                                htmlFor={`basic_${item.id}`}
                                            >
                                                {item.name}
                                            </label>

                                            {/* show only for vehcile and adone age which speical addon   */}
                                            { item?.note &&  
                                            (
                                                <div
                                                    className="applicable-info-wrap"
                                                    ref={openApplicableInfoId === item.id ? applicableInfoRef : null}
                                                >
                                                    <span className="applicable-txt">
                                                        {item?.note}
                                                        <button
                                                            type="button"
                                                            className="applicable-info-btn"
                                                            onClick={(event) => {
                                                                event.preventDefault();
                                                                event.stopPropagation();
                                                                setOpenApplicableInfoId((prev) => (prev === item.id ? null : item.id));
                                                            }}
                                                        >
                                                            <i className="ic-info-icon1 addon-i-info"></i>
                                                        </button>
                                                    </span>

                                                    {openApplicableInfoId === item.id && (
                                                        <div className="applicable-info-popup">
                                                            {item.note}
                                                        </div>
                                                    )}
                                                </div>
                                            )}  

                                              {/* Coverage dropdown – show ONLY when checkbox is checked */}
                                        {item.coverage_list?.length > 0 && state.checked && (
                                            <div className="coverage-amt-dropdown">
                                                <ReactSelect
                                                    options={item.coverage_list.map((c: any) => ({
                                                        value: c.value,
                                                        label: HELPER.addCurrencyFormatting(c.label)
                                                    }))}
                                                    value={state.coverage || null}

                                                    handleChange={(e: any) =>
                                                        handleCoverageChangeLoc(item, {
                                                            ...e,
                                                            premium_amount: item.coverage_list.find(
                                                                (c: any) => c.value === e.value
                                                            )?.premium_amount
                                                        })
                                                    }
                                                    placeholder={translations?.CREATE_APP?.CHOOSE_COVERAGE_AMOUNT}
                                                    fieldKey={`coverage_${item.id}`}
                                                    fieldSetClassName=""
                                                    innerClass="select-partenrt-dropdown"
                                                />
                                            </div>
                                        )}

                                        {/* Passenger dropdown */}
                                        {item.seat_capacity_list?.length > 0 && (state.checked) && (
                                            <div className="coverage-amt-dropdown m-t-10">
                                                <ReactSelect
                                                    options={item.seat_capacity_list.map((s: any) => ({
                                                        value: s.value,
                                                        label: s.label
                                                    }))}
                                                    value={state.passengers || null}
                                                    handleChange={(e: any) => handlePassengerChangeLoc(item, e)}
                                                    placeholder={translations?.CREATE_APP?.NO_OF_PASSENGER}
                                                    fieldKey={`passenger_${item.id}`}
                                                    fieldSetClassName=""
                                                    innerClass="select-partenrt-dropdown"
                                                />
                                            </div>
                                        )}
                                        </div>

                                      


                                        {isRuleEngine && (state.checked) && (
                                            <span className="add-on-input add-on-premium-input">
                                                {premiumText}
                                            </span>
                                        )}

                                        {/* with out rule engine field */}
                                        {!isRuleEngine && state.checked && (
                                            <div className="material add-on-manual-premium-field">
                                                <input
                                                    spellCheck={false}
                                                    type="text"
                                                    placeholder=" "
                                                    className="form-input"
                                                    // value={premiumAmt ?? ""}
                                                    value={HELPER.addCurrencyFormatting(state.premium || 0)}
                                                    onChange={(event) => {
                                                        const inputValue = event.target.value;
                                                        const finalValue = HELPER.removeCurrencyFormattingId(inputValue)
                                                        handleManualPremiumChangeLoc(item, finalValue);
                                                    }}
                                                />
                                                <label
                                                    className="form-label"
                                                    data-label={translations?.CREATE_APP?.ENTER_PREMIUM}
                                                ></label>
                                                {error[`premium_${item.id}`] && (
                                                    <span className="error-txt">
                                                        {error[`premium_${item.id}`]}
                                                    </span>
                                                )}
                                            </div>
                                        )}

                                    </li>
                                )
                            })}
                        </ul>
                    </div>

                    {/* {specialAddons.length > 0 && (
                        <>
                            <div className="row m-t-30">
                                <div className="heading-help-btn col-md-12 col-xs-12 p-sm-b">
                                    <h2>{translations?.CREATE_APP?.SPECIAL_ADDONS}</h2>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12 col-xs-12">
                                    <div className="basic-add-on-list">
                                        <ul>
                                            {specialAddons.map((item: any) => {
                                                const state = addonState[item.id] || {};
                                                
                                                return (
                                                    <li key={item.id}>
                                                        <div className="custom-control custom-checkbox">
                                                            <input
                                                                id={`special_${item.id}`}
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                checked={state.checked || false}
                                                                //disabled={!item.is_enable}
                                                                onChange={(e) =>
                                                                    handleCheckboxChangeLoc(item, e.target.checked)
                                                                }
                                                            />
                                                            <label
                                                                className="custom-control-label"
                                                                htmlFor={`special_${item.id}`}
                                                            >
                                                                {item.name}
                                                            </label>
                                                        </div>

                                                        {!isRuleEngine && state.checked && (
                                                            <div className="material">
                                                                <input
                                                                    spellCheck={false}
                                                                    type="text"
                                                                    placeholder=" "
                                                                    className="form-input"
                                                                    value={HELPER.addCurrencyFormatting(premiumAmt || 0)}
                                                                    onChange={(event) => {
                                                                        const inputValue = event.target.value;
                                                                        const finalValue = HELPER.removeCurrencyFormattingId(inputValue)
                                                                        handleManualPremiumChangeLoc(item, finalValue);
                                                                    }}
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    data-label={translations?.CREATE_APP?.ENTER_PREMIUM}
                                                                ></label>
                                                                {error[`premium_${item.id}`] && (
                                                                    <span className="error-txt">
                                                                        {error[`premium_${item.id}`]}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}
                                                    </li>

                                                )
                                            })}

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </>
                    )} */}
                </div>
            </div>

            <div className="btn-continue add-on-cost-txt-btn">
                <div className="total-add-on-cost"> {translations?.CREATE_APP?.TOTAL_ADDON_COST} - {totalPremiumAmt}</div>
                <button className="btn-line" onClick={()=>handleSkip()}>{translations?.COMMON_MSG?.SKIP}</button>
                <button className="btn-primary " onClick={handleSubmit}>{sectionList?.[CREATE_PAGE_INDEX.ADDONS]?.btn?.title}</button>
            </div>

            {

                <CommonModel filterType="Get Help" show={showHelpModel} handleClose={() => { setShowHelpModel(false) }} data={addOnQuesAns} />

            }
        </div>
    )

}
export default Addons
